/**
 * The People list's pure parts.
 *
 * Split out from PeopleRedesign.js for one blunt reason: that file imports
 * userService, which imports axios, and CRA 5's Jest does not transform
 * axios v1's ESM entry point — so anything importing the page cannot be tested
 * at all. The same split exists for apiGeneration.js and userEndpoints.js.
 */

/** "2026/08/31 09:14:00" and ISO both arrive; neither is worth parsing. */
export const formatModified = (value) => {
  if (typeof value !== "string" || value.length < 10) return "—";
  const [date, time = ""] = value.replace("T", " ").split(" ");
  const [year, month, day] = date.split(/[-/]/);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const name = months[Number(month) - 1];
  if (!name) return value;
  return `${Number(day)} ${name} ${year}${time ? `, ${time.slice(0, 5)}` : ""}`;
};

/** Search, role and status, applied together. */
export const filterUsers = (users, { query = "", role = "all", status = "all" } = {}) => {
  const needle = query.trim().toLowerCase();
  return (users || []).filter((user) => {
    if (needle && ![user.name, user.email, user.role].some((field) =>
      String(field || "").toLowerCase().includes(needle),
    )) {
      return false;
    }
    if (role !== "all" && user.role !== role) return false;
    if (status === "active" && !user.active) return false;
    if (status === "inactive" && user.active) return false;
    return true;
  });
};
